import { useDispatch, useSelector } from "react-redux";
import numberFormat from "lib/numberFormat";
import { AUTH_SUCCESS, handleErrors } from "store/auth";
import { axiosInstance } from "../auth";
import { saveAs } from "file-saver";
export const UPDATE_FILED = "coreUpdateField";
export const CLEAR = "coreClear";
export const updateField = ({ prop, value }) => ({
  type: UPDATE_FILED,
  payload: { prop, value },
});

export const useCore = () => {
  const core = useSelector((state) => state.core);
  const dispatch = useDispatch();
  return {
    ...core,
    list,
    clear,
    fetchList,
    getProductCategories,
    getProductTags,
    getTagsType,
    getChannels,
    getGenres,
    getUsers,
    getRoles,
    getAbilities,
    getActivityFields,
    getCountries,
    getSeries,
    getSeasons,
    getCasts,
    dispatch,
    getProductOwners,
    getSliders,
    getMenus,
    getProducts,
    getLanguages,
    getPackages,
    getFestivals,
    getGlobalSearch,
    getCrmSearch,
    getProductViewCount,
    getCrm,
    chargeWallet,
    withdrawWallet,
    editSubscription,
    addSubscription,
    getDirectorDashboard,
    getCrmUserViews,
    getUserFestivals,
    getDirectorReportSingle,
    getDirectorReportMovies,
    getDirectorReportScreening,
    getCafes,
    useCafeTicket,
    getFestival,
    manageFestivalWidgets,
    getDirectorYearlyReport,
    getParentMenuItems,
    downloadFestivalReport,
    deleteLiveStream,
    createLiveStream,
    printInvoice,
    storeDirectorProfile,
  };
};

export const printInvoice = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/panel/orders/${id}/invoice`, {
      responseType: "blob",
    });

    cb(URL.createObjectURL(result.data));
  } catch (e) {
    console.log(e);
    handleErrors(e);
  }
};

function list(value) {
  return value.map((item) => {
    let data = {
      value: item.id,
    };

    let label = item.name || item.title || item.fa_name || item.full_name || "";
    // if user or agent => add last name & mobile
    if (item.first_name) {
      label = item.first_name;
      if (item.last_name) {
        label += " " + item.last_name;
      }
    }
    // if service & product add price
    if (item.price) {
      label += " (" + numberFormat.toOn(item.price) + " ریال)";
    }

    // add price for servie & product
    if (item.price) {
      data.price = item.price;
    }

    // add display name for role
    if (item.display_name) {
      label = item.display_name;
    }
    data.label = label;
    return data;
  });
}

export const clear = () => ({
  type: CLEAR,
});

async function fetchList(
  dispatch,
  filters,
  rel,
  key,
  route,
  disableList = false
) {
  try {
    dispatch(updateField({ prop: `${key}Load`, value: true }));
    let url = `/panel/core/${route}?pagination=false&rel=${rel || ""}`;
    // handle filters

    if (filters) {
      Object.keys(filters).map((item, index) => {
        if (item.length <= 0) {
          return;
        }

        if (filters[item].length > 0 && Array.isArray(filters[item])) {
          filters[item].map((i, index) => {
            url += `&${item}[${index}]=${i}`;
          });
        } else if (!!filters[item]) {
          url += `&${item}=${filters[item]}`;
        }
      });
    }
    const result = await axiosInstance.get(url);
    dispatch(
      updateField({
        prop: key,
        value: disableList ? result.data : list(result.data),
      })
    );
    dispatch(updateField({ prop: `${key}Load`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `${key}Load`, value: false }));

    handleErrors(e);
  }
}

export const getPostCategories = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters || {},
    rel,
    "postCategories",
    "post-categories"
  );
};

export const getProductCategories = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters || {},
    rel,
    "productCategories",
    "product-categories"
  );
};

export const getProductTags = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "productTags", "product-tags");
};

export const getTagsType = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "tagsType", "tag-types");
};

export const getChannels = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "channels", "channels");
};

export const getGenres = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "genres", "genres");
};
export const getLanguages = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters || {}, rel, "languages", "languages");
};
export const getUsers = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "users", "users");
};
export const getRoles = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "roles", "roles");
};
export const getAbilities = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "abilities", "abilities", true);
};
export const getActivityFields = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "activityFields", "activity-fields");
};
export const getCountries = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "countries", "countries");
};
export const getCasts = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "casts", "casts");
};
export const getSliders = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "sliders", "sliders");
};
export const getMenus = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "menus", "menus");
};

export const getParentMenuItems = (menu_id, filters, rel) => async (
  dispatch
) => {
  await fetchList(
    dispatch,
    filters,
    rel,
    "parentMenuItems",
    "parent-menu-items/" + menu_id
  );
};

export const getSeries = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "series", "series", true);
};
export const getProductOwners = (filters, rel) => async (dispatch) => {
  await fetchList(
    dispatch,
    filters,
    rel,
    "productOwners",
    "product-owners",
    true
  );
};
export const getCafes = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "cafes", "cafes", true);
};

export const getGlobalSearch = (key) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `globalSearchLoad`, value: true }));
    if (key.length > 1) {
      const result = await axiosInstance.get(
        `/panel/core/search-every-where/${key}`
      );
      dispatch(updateField({ prop: `globalSearch`, value: result.data }));
    } else {
      dispatch(
        updateField({
          prop: `globalSearch`,
          value: {
            users: [],
            products: [],
            festivals: [],
            packages: [],
          },
        })
      );
    }

    dispatch(updateField({ prop: `globalSearchLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `globalSearchLoad`, value: false }));
    handleErrors(e);
  }
};

export const getCrmSearch = (key) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    dispatch(updateField({ prop: `crmUser`, value: null }));
    if (key.length > 1) {
      const result = await axiosInstance.get(`/panel/crm?key=${key}`);
      dispatch(updateField({ prop: `crmSearch`, value: result.data }));
    } else {
      dispatch(updateField({ prop: `crmSearch`, value: [] }));
    }

    dispatch(updateField({ prop: `crmLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const getCrm = (id) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.get(`/panel/crm/${id}`);
    dispatch(updateField({ prop: `crmUser`, value: result.data }));

    dispatch(updateField({ prop: `crmLoad`, value: false }));
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    dispatch(updateField({ prop: `crmUser`, value: null }));
    handleErrors(e);
  }
};

export const getFestival = (id) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/panel/festivals/${id}`);
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};
export const getProductViewCount = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.get(`/panel/products/${id}/view-report`);
    cb(result.data);
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};

export const manageFestivalWidgets = (id, values) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(
      `/panel/festivals/${id}/manage-widgets`,
      values
    );
    return result.data;
  } catch (e) {
    handleErrors(e);
  }
};

export const storeDirectorProfile = (id, values, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.post(
      `/panel/directors/${id}/store-director-profile`,
      values
    );
    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const chargeWallet = (id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.post(
      `/panel/crm/${id}/charge-wallet`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};
export const withdrawWallet = (id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));

    const result = await axiosInstance.post(
      `/panel/crm/${id}/withdraw-wallet`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const useCafeTicket = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.post(`/panel/me/use-cafe-ticket/${id}`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};

export const createLiveStream = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(`/panel/lives/${id}/create-stream`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const deleteLiveStream = (id, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.put(`/panel/lives/${id}/delete-stream`);

    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const getDirectorDashboard = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/panel/crm/${user_id}/get-director-dashboard-data`;

    if (from) {
      url = `/panel/crm/${user_id}/get-director-dashboard-data?from=${from}`;
    }
    if (to) {
      url = `/panel/crm/${user_id}/get-director-dashboard-data?to=${to}`;
    }
    if (to && from) {
      url = `/panel/crm/${user_id}/get-director-dashboard-data?from=${from}&to=${to}`;
    }
    const result = await axiosInstance.get(url);

    cb(result.data);
  } catch (e) {
    handleErrors(e);
  }
};

export const getCrmUserViews = (user_id, cb, params = {}) => async (
  dispatch
) => {
  try {
    let query = new URLSearchParams();

    if (params.page) query.append("page", params.page);
    if (params.per_page) query.append("per_page", params.per_page);
    if (params.search) query.append("search", params.search);

    const url = `/panel/crm/${user_id}/views?${query.toString()}`;
    const result = await axiosInstance.get(url);

    cb(result.data);
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportScreening = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/panel/crm/${user_id}/get-director-screening-report`;

    if (from) {
      url = `/panel/crm/${user_id}/get-director-screening-report?from=${from}`;
    }
    if (to) {
      url = `/panel/crm/${user_id}/get-director-screening-report?to=${to}`;
    }
    if (to && from) {
      url = `/panel/crm/${user_id}/get-director-screening-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};
export const getDirectorYearlyReport = (
  user_id,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/panel/directors/${user_id}/report`;

    if (from) {
      url = `/panel/directors/${user_id}/report?from_year=${from}`;
    }
    if (to) {
      url = `/panel/directors/${user_id}/report?to_year=${to}`;
    }
    if (to && from) {
      url = `/panel/directors/${user_id}/report?from_year=${from}&to_year=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "director_yearly_report" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportMovies = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/panel/crm/${user_id}/get-director-movies-report`;

    if (from) {
      url = `/panel/crm/${user_id}/get-director-movies-report?from=${from}`;
    }
    if (to) {
      url = `/panel/crm/${user_id}/get-director-movies-report?to=${to}`;
    }
    if (to && from) {
      url = `/panel/crm/${user_id}/get-director-movies-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const getDirectorReportSingle = (
  user_id,
  cb,
  from = null,
  to = null
) => async (dispatch) => {
  try {
    let url = `/panel/crm/${user_id}/get-director-single-report`;

    if (from) {
      url = `/panel/crm/${user_id}/get-director-single-report?from=${from}`;
    }
    if (to) {
      url = `/panel/crm/${user_id}/get-director-single-report?to=${to}`;
    }
    if (to && from) {
      url = `/panel/crm/${user_id}/get-director-single-report?from=${from}&to=${to}`;
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_director" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const downloadFestivalReport = (festival_id) => async (dispatch) => {
  try {
    let url = `/panel/festivals/${festival_id}/get-festival-report`;

    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "festival_report" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};
export const editSubscription = (u_id, s_id, values, cb) => async (
  dispatch
) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    const result = await axiosInstance.post(
      `/panel/crm/${u_id}/edit-subscription/${s_id}`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};
export const addSubscription = (u_id, values, cb) => async (dispatch) => {
  try {
    dispatch(updateField({ prop: `crmLoad`, value: true }));
    const result = await axiosInstance.post(
      `/panel/crm/${u_id}/add-subscription`,
      values
    );
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    cb();
  } catch (e) {
    dispatch(updateField({ prop: `crmLoad`, value: false }));
    handleErrors(e);
  }
};

export const getSeasons = (id, filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "seasons", `serie-seasons/${id}`);
};

export const getFestivals = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "festivals", "festivals");
};

export const getUserFestivals = (cb) => async (dispatch) => {
  try {
    let url = `/panel/festivals?per_page=1000&page=1`;
    const result = await axiosInstance.get(url);
    cb(result.data);
  } catch (e) {
    handleErrors(e);
  }
};

export const getProducts = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "products", "products", true);
};

export const getPackages = (filters, rel) => async (dispatch) => {
  await fetchList(dispatch, filters, rel, "packages", "packages");
};
